<template>
  <el-container class="spa-container">
    <el-aside width="200px">
      <Aside/>
    </el-aside>
    <el-container class="right-container">
      <el-header>
        <Header/>
      </el-header>
      <el-main>
        <keep-alive :include="['MenuAes', 'MenuSnowflake']">
          <router-view></router-view>
        </keep-alive>
      </el-main>
      <el-footer>
        <Footer/>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import Aside from '@/components/spalayouts/Aside.vue'
import Header from '@/components/spalayouts/Header.vue'
import Footer from '@/components/spalayouts/Footer.vue'

export default {
  name: "SPA",
  components: {
    Aside,
    Header,
    Footer
  },
  data() {
    return {}
  },// data
  methods: {},// methods
  watch: {
    // 'searchParamVo.topPath': {handler: function (val, oldVal) {if (val) {this.searchParamVo.topPath = val;this.searchParamVo.topPath = '';}}, deep: true},
  },// watch
  mounted() {
    // this.init();
  },// mounted
}
</script>

<style scoped>
.spa-container {
  height: 100%;
}

.right-container {
  display: flex;
  flex-direction: column;
}

.el-header {
  padding: 0;
  margin: 0;
}

.el-main {
  padding: 0;
  margin: 0;
  flex: 1;
  overflow: auto;
}

.el-footer {
  padding: 0;
  margin: 0;
}
</style>

<style>
.el-container {
  margin: 0 !important;
  padding: 0 !important;
}
</style>